module.exports = __webpack_public_path__ + "static/media/DSC_0167.60d2e78a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/DSC_0167.jpg
// module id = 639
// module chunks = 0